/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;

